import { currencySchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchCurrencies = async () => {
  const response: any = await fetchApi('/currencies')

  return (response.items ?? []).map((item: any) =>
    currencySchema.parse({
      code: item.data?.code,
      name: item.data?.name,
      sign: item.data?.sign,
      roundUp: item.data?.round_up,
      signBefore: item.data?.sign_before,
      default: item.data?.default,
    }),
  )
}

export type CurrencyData = Awaited<ReturnType<typeof fetchCurrencies>>[number]
